module.exports = __webpack_public_path__ + "img/enviar_notas.dbb44dee.svg";